import { useSearchParams, useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

const REASONS = {
    missing_transaction: "Paramètre de transaction manquant.",
    transaction_not_found: "Transaction introuvable sur MonCash.",
    no_order_reference: "Référence de commande manquante.",
    invalid_order_id: "Identifiant de commande invalide.",
    store_not_found: "Boutique introuvable.",
    insufficient_amount: "Montant payé insuffisant.",
    server_error: "Une erreur interne est survenue.",
};

export default function PaiementErreurPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const reason = searchParams.get("reason") || "server_error";
    const message = REASONS[reason] || "Une erreur est survenue lors du paiement.";

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center space-y-6">
                <XCircle className="h-16 w-16 text-red-500 mx-auto" />
                <h2 className="text-2xl font-bold text-gray-900">Paiement non confirmé</h2>
                <p className="text-gray-600 text-sm">{message}</p>
                <div className="flex flex-col gap-3 pt-2">
                    <Button variant="outline" className="w-full" onClick={() => navigate("/mes-boutiques")}>
                        Retour à mes boutiques
                    </Button>
                    <a href="mailto:support@buymoreeasy.com" className="text-sm text-orange-500 hover:underline">
                        Contacter le support
                    </a>
                </div>
            </div>
        </div>
    );
}
